<!-- pagination -->

<!-- ── Both enabled: single row ─────────────────────────────────────── -->
<div *ngIf="EnablePageSize && EnableNavigation"
  class="d-flex justify-content-between align-items-center my-2 flex-wrap gap-2"  > 

  <!-- Left: "Show [25] entries  Showing 1–25 of 63" -->
  <div class="pg-size">
    <span class="pg-size-ctl">
      <span>Show</span>
      <select class="form-select form-select-sm" name="pageSizeSelect" aria-label="Rows per page"
        (change)="onPageSizeChanged($event)" [disabled]="Disabled" [(ngModel)]="pageSize">
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
        <option [value]="1000">ALL</option>
      </select>
      <span>entries</span>
    </span>
    <span class="pg-info" *ngIf="totalRecords > 0">Showing <b>{{start}}–{{end}}</b> of <b>{{totalRecords}}</b></span>
    <span class="pg-info" *ngIf="!totalRecords">No records</span>
    <ng-content></ng-content>
  </div>

  <!-- Right: page info + navigation buttons -->
  <div class="d-flex align-items-center gap-2">
    <small class="text-muted">Page {{currentPage}} of {{totalPages}}</small>
    <ul class="pagination mb-0">
      <li class="page-item" (click)="goToFirstPage()" [ngClass]="{'disabled': currentPage === 1 || Disabled}">
        <a class="page-link" aria-label="First">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
        </a>
      </li>
      <li class="page-item" (click)="goToPreviousPage()" [ngClass]="{'disabled': currentPage === 1 || Disabled}">
        <a class="page-link" aria-label="Previous">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </a>
      </li>
      <li class="page-item" [ngClass]="{'active': currentPage === page, 'disabled': Disabled}"
        *ngFor="let page of getPagesToShow()" (click)="goToNumberPage(page)">
        <a class="page-link">{{ page }}</a>
      </li>
      <li class="page-item" (click)="goToNextPage()" [ngClass]="{'disabled': currentPage === totalPages || Disabled}">
        <a class="page-link" aria-label="Next">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </a>
      </li>
      <li class="page-item" (click)="goToLastPage()" [ngClass]="{'disabled': currentPage === totalPages || Disabled}">
        <a class="page-link" aria-label="Last">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
        </a>
      </li>
    </ul>
  </div>

</div>

<!-- ── Size selector only ────────────────────────────────────────────── -->
<!-- on phones this row hides when the navigation row below shows the same list (the size selector moves there) -->
<div class="pg-size pg-size-row my-2" *ngIf="EnablePageSize && !EnableNavigation">
  <span class="pg-size-ctl">
    <span>Show</span>
    <select class="form-select form-select-sm" name="pageSizeSelect" aria-label="Rows per page"
      (change)="onPageSizeChanged($event)" [disabled]="Disabled" [(ngModel)]="pageSize">
      <option [value]="10">10</option>
      <option [value]="25">25</option>
      <option [value]="50">50</option>
      <option [value]="100">100</option>
      <option [value]="1000">ALL</option>
    </select>
    <span>entries</span>
  </span>
  <span class="pg-info" *ngIf="totalRecords > 0">Showing <b>{{start}}–{{end}}</b> of <b>{{totalRecords}}</b></span>
  <span class="pg-info" *ngIf="!totalRecords">No records</span>
  <ng-content></ng-content>
</div>

<!-- ── Navigation only ───────────────────────────────────────────────── -->
<div *ngIf="!EnablePageSize && EnableNavigation" class="pg-nav">
  <nav class="d-flex justify-content-between align-items-center flex-wrap gap-2" aria-label="Pagination">
    <!-- Left: "1–25 of 63 records · Page 1/3"; on phones "Show [25] | 1–25 of 63 records · Page 1/3" -->
    <span class="pg-left">
      <span class="pg-size-ctl pg-sm-only">
        <span>Show</span>
        <select class="form-select form-select-sm" name="pageSizeSelectBottom" aria-label="Rows per page"
          (change)="onPageSizeChanged($event)" [disabled]="Disabled" [(ngModel)]="pageSize">
          <option [value]="10">10</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>
          <option [value]="100">100</option>
          <option [value]="1000">ALL</option>
        </select>
      </span>
      <span class="pg-info" *ngIf="totalRecords > 0"><b>{{start}}–{{end}}</b> of <b>{{totalRecords}}</b> records · Page {{currentPage}}/{{totalPages}}</span>
      <span class="pg-info" *ngIf="!totalRecords">No records</span>
    </span>
    <ul class="pagination mb-0 justify-content-end">
      <li class="page-item" (click)="goToFirstPage()" [ngClass]="{'disabled': currentPage === 1 || Disabled}">
        <a class="page-link" aria-label="First">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
        </a>
      </li>
      <li class="page-item" (click)="goToPreviousPage()" [ngClass]="{'disabled': currentPage === 1 || Disabled}">
        <a class="page-link" aria-label="Previous">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </a>
      </li>
      <li class="page-item" [ngClass]="{'active': currentPage === page, 'disabled': Disabled}"
        *ngFor="let page of getPagesToShow()" (click)="goToNumberPage(page)">
        <a class="page-link">{{ page }}</a>
      </li>
      <li class="page-item" (click)="goToNextPage()" [ngClass]="{'disabled': currentPage === totalPages || Disabled}">
        <a class="page-link" aria-label="Next">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </a>
      </li>
      <li class="page-item" (click)="goToLastPage()" [ngClass]="{'disabled': currentPage === totalPages || Disabled}">
        <a class="page-link" aria-label="Last">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
        </a>
      </li>
    </ul>
  </nav>
</div>
